import React from "react";
import { withRouter } from "react-router-dom";
import AccountRecoveryMethodForm from "../../forms/AccountRecoveryMethodForm";

const AccountRecoveryMethodPage = () => (
  <div
    id="page-container"
    className="row align-items-center justify-content-center"
  >
    <AccountRecoveryMethodForm />
  </div>
);

export default withRouter(AccountRecoveryMethodPage);



// WEBPACK FOOTER //
// ./src/components/pages/AccountRecoveryMethodPage/AccountRecoveryMethodPage.jsx